import { Modal } from '@mui/material'

import { CloseIcon } from '@assets/svgs/CloseIcon'
import { Button } from '@components/shared/Button'

import type { BaseModalProps } from './types'

import * as S from './styles'

export const BaseModal = ({
  open,
  title,
  headerIcon,
  children,
  width = 400,
  heightContainer,
  footer,
  onClose
}: BaseModalProps) => {
  return (
    <Modal open={open} onClose={() => onClose(false)}>
      <S.Container sx={{ maxWidth: width, height: heightContainer }}>
        <S.Header>
          <S.TitleBox>
            {headerIcon}
            {!!title && title}
          </S.TitleBox>

          <S.CloseIcon onClick={() => onClose(false)}>
            <CloseIcon />
          </S.CloseIcon>
        </S.Header>

        <S.Content style={{ height: !!footer ? `calc(100% - 165px)` : 'calc(100% - 78px)' }}>{children}</S.Content>

        {!!footer && (
          <S.Footer>
            <Button width="100%" colorType="outlineBlue" onClick={() => onClose(false)}>
              {footer.cancelButtonText}
            </Button>
            <Button type="submit" width="100%" colorType="solidBlue" onClick={footer.onConfirm}>
              {footer.confirmButtonText}
            </Button>
          </S.Footer>
        )}
      </S.Container>
    </Modal>
  )
}
